export default __webpack_public_path__ + "static/media/SharpSans-semi-bold.b8d3cf8f.otf";